export const STATUS_PILL_CLASS = {
  Success: "bg-emerald-100 text-emerald-700",
  Failed: "bg-red-100 text-red-700",
  Pending: "bg-amber-100 text-amber-700",
  "Not Published": "bg-orange-100 text-orange-700",
};

export const DEFAULT_DATE = new Date();
export const STALE_PENDING_MINUTES = 20;
export const UPDATE_POLL_INTERVAL_MS = 3000;
export const UPDATE_POLL_TIMEOUT_MS = 180000;
export const PAGE_SIZE = 20;
export const SEARCH_DEBOUNCE_MS = 400;
export const PDF_SLIDE_MS = 160;
export const PDF_SLIDE_SETTLE_MS = 80;
export const EPAPER_LIST_PATH = "/services/epaper/editions";

export const EMPTY_PREVIEW_MODAL = {
  isOpen: false,
  editionName: "",
  pdfPath: "",
  previewUrl: "",
  mapPreview: "",
  allPagesPdfPaths: [],
  currentPageIndex: 0,
};

export const DAY_PICKER_CLASS_NAMES = {
  months: "flex",
  month: "space-y-3",
  caption: "flex items-center justify-between px-1 font-semibold text-gray-800",
  nav: "flex items-center gap-1",
  nav_button: "h-8 w-8 rounded-md border border-gray-200 text-gray-600 hover:bg-gray-100",
  table: "w-full border-collapse",
  head_row: "flex",
  head_cell: "h-9 w-9 text-center text-xs font-medium text-gray-500",
  row: "mt-1 flex w-full",
  cell: "h-9 w-9 p-0",
  day: "h-9 w-9 rounded-md text-sm font-medium text-gray-700 hover:bg-cyan-50 hover:text-cyan-700",
  day_selected: "bg-cyan-600 text-white hover:bg-cyan-600 hover:text-white",
  day_range_start: "bg-cyan-600 text-white hover:bg-cyan-600 hover:text-white",
  day_range_end: "bg-cyan-600 text-white hover:bg-cyan-600 hover:text-white",
  day_range_middle: "bg-cyan-100 text-cyan-800 rounded-none",
  day_today: "border border-cyan-200",
  day_outside: "text-gray-300",
};
